export const PROMOTIONS = {
    PROMOTIONS_PAGE_TITLE: "title-input",
    PROMOTIONS_NAME: "PROMOTIONS_name",
    PROMOTIONS_DESCRIPTION: "PROMOTIONS_description",
    PROMOTIONS_ENABLED: "PROMOTIONS_enabled",
    PROMOTIONS_ID: "PROMOTIONS_id",
    LOADING_TEXT: "PROMOTIONS_loading_text",
    CREATE_NEW_PROMOTION: "PROMOTIONS_create_new_promotion",

    ORDER_FIELD_RESTRICTIONS: "ORDER_FIELD_restrictions",
    ORDER_FIELD_RESTRICTIONS_OPTION: "ORDER_FIELD_restrictions_option",
    ORDER_QUANTITY_FIELD_AT_LEAST: "ORDER_QUANTITY_field_at_least",
    ORDER_QUANTITY_FIELD_AT_MOST: "ORDER_QUANTITY_fiead_at_most",
    ORDER_AMOUNT_FIELD_AT_LEAST: "ORDER_AMOUNT_field_at_least",
    ORDER_AMOUNT_FIELD_AT_MOST: "ORDER_AMOUNT_field_at_most",
    SHIPPED_AMOUNT_FIELD_AT_LEAST: "SHIPPED_AMOUNT_field_at_least",
    SHIPPED_AMOUNT_FIELD_AT_MOST: "SHIPPED_AMOUNT_field_at_most",

    PRODUCT_QUANTITY_FIELD_AT_LEAST: "PRODUCT_QUANTITY_field_at_least",
    PRODUCT_QUANTITY_FIELD_AT_MOST: "PRODUCT_QUANTITY_fiead_at_most",
    PRODUCT_AMOUNT_FIELD_AT_LEAST: "PRODUCT_AMOUNT_field_at_least",
    PRODUCT_AMOUNT_FIELD_AT_MOST: "PRODUCT_AMOUNT_field_at_most",

    PRODUCT_LEVEL_FIELD_SELECT_FIELD: "PRODUCT_LEVEL_FIELD_select_field",
    PRODUCT_TOTAL: "PRODUCT_TOTAL_component",

    ORDER_LEVEL_FIELD_SELECT_FIELD: "ORDER_LEVEL_FIELD_select_field",
    ORDER_LEVEL_FIELD_MULTI_SELECT: "ORDER_LEVEL_FIELD_multi_select",
    ORDER_LEVEL_FIELD_LOOKUP_SELECT_FIELD: "ORDER_LEVEL_FIELD_LOOKUP_select_field",
    ORDER_LEVEL_FIELD_TEXTFIELD: "ORDER_LEVEL_FIELD_textfield",
    ORDER_DELIVERY_DATE_FROM: "ORDER_DELIVERY_DATE_from",
    ORDER_DELIVERY_DATE_TO: "ORDER_DELIVERY_DATE_to",

    CONDITIONAL_DATE_RANGE_SELECT_FIELD: "CONDITIONAL_DATE_RANGE_select_field",
    CONDITIONAL_DATE_RANGE_FROM: "CONDITIONAL_DATE_RANGE_from",
    CONDITIONAL_DATE_RANGE_TO: "CONDITIONAL_DATE_RANGE_to",

    THRESHOLD_TOGGLE: "THRESHOLD_toggle",
    THRESHOLD_CHECKBOX: "THRESHOLD_checkbox",
    THRESHOLD_HINTBADGE: "THRESHOLD_hintbadge",
    THRESHOLD_TEXTFIELD: "THRESHOLD_textfield",

    SELECT_ALL_GROUPS: "PROMOTIONS_select_all_groups",
    FIELD_CUSTOMER_TYPE: "PROMOTIONS_customer_type",
    OPTION_ALL_CUSTOMERS: "PROMOTIONS_all_customers",
    CUSTOMER_GROUP_AUTOCOMPLETE: "PROMOTIONS_customer_groups_autocomplete",
    CUSTOMER_GROUP_SELECTED: "PROMOTIONS_customer_groups_selected",
    OPTION_CUSTOMER_GROUPS: "PROMOTIONS_customer_groups",
    OPTION_SINGLE_COMPANY: "PROMOTIONS_single_company",
    OPTION_COMPANIES: "PROMOTIONS_companies",

    SELECT_COMPANIES: "PROMOTIONS_select_companies",
    COMPANIES_AUTOCOMPLETE: "PROMOTIONS_companies_autocomplete",
    COMPANIES_SELECTED: "PROMOTIONS_companies_selected",
    AUTOCOMPLETE: "PROMOTIONS_autocomplete",

    TYPE_ORDER: "PROMOTIONS_order_type",
    TYPE_PRODUCT: "PROMOTIONS_product_type",
    TYPE_PRODUCT_GROUPS: "PROMOTIONS_product_group_type",
    TYPE_SECTION_RADIOGROUP: "PROMOTIONS_type_section_radiogroup",
    CURRENCY_SELECTFIELD: "PROMOTIONS_currency_selectfield",

    COMBINE_ORDER_PROMOS: "PROMOTIONS_combine_order_promos",
    COMBINE_PRODUCT_PROMOS: "PROMOTIONS_combine_product_promos",
    COMBINE_COMPANY_DISCOUNTS: "PROMOTIONS_combine_company_discounts",
    COMBINE_PROMOTIONS_HINTBADGE: "PROMOTIONS_combine_promotions_hintbadge",

    SELECTOR_PRODUCT: "",
    SELECTOR_ORDER: "",

    DISCOUNT_APPLIED_ADDITIONAL_FIELD: "PROMOTIONS_discount_applied_additional_field",
    DISCOUNT_APPLIED_DELETE_BUTTON: "PROMOTIONS_DISCOUNT_APPLIED_delete_button",
    DISCOUNT_APPLIED_ADD_BUTTON: "PROMOTIONS_DISCOUNT_APPLIED_add_button",

    ORDER_DISCOUNT: {
        PERCENTAGE_OFF: "percentage_off",
        AMOUNT_OFF: "amount_off",
        FREE_SHIPPING: "free_shipping",
        NET_TERMS_EXTENSION: "net_terms_extension",
    },
    PRODUCT_DISCOUNT: {
        PERCENTAGE_OFF: "percentage_off",
        AMOUNT_OFF_EACH: "amount_off_each",
        AMOUNT_OFF_SUBTOTAL: "amount_off_subtotal",
    },

    ACTIVE_DATE_DATEPICKER_START: "PROMOTIONS_active_date_datepicker_start",
    ACTIVE_DATE_DATEPICKER_END: "PROMOTIONS_active_date_datepicker_end",
    ACTIVE_DATE_TIMEPICKER_START: "PROMOTIONS_active_date_timepicker_start",
    ACTIVE_DATE_TIMEPICKER_END: "PROMOTIONS_active_date_timepicker_end",
    ACTIVE_DATE_ERRORS: "PROMOTIONS_active_date_errors",

    PRODUCT_DATE_RULE_DATEPICKER_EARLIEST: "PROMOTIONS_product_date_rule_datepicker_earliest",
    PRODUCT_DATE_RULE_DATEPICKER_LATEST: "PROMOTIONS_product_date_rule_datepicker_latest",
    PRODUCT_SELECT_RULE_DROPDOWN: "PROMOTIONS_product_select_rule_dropdown",
    PRODUCT_SELECT_RULE_MULTISELECT: "PROMOTIONS_product_select_rule_multiselect",
    PRODUCT_SELECT_RULE_DIALOG: "PROMOTIONS_product_select_rule_dialog",

    SELECT_PRODUCT_RULE_TEXTFIELD: "PROMOTIONS_select_product_rule_textfield",
    SELECT_PRODUCT_RULE_SEARCH_ICON: "PROMOTIONS_select_product_rule_search_icon",
    SELECT_PRODUCT_RULE_CANCEL: "PROMOTIONS_select_product_rule_cancel",

    PRODUCT_ITEMS_LIST_LIST: "PROMOTIONS_product_items_list_list",
    PRODUCT_ITEMS_LIST_VIEW: "PROMOTIONS_product_items_list_view",

    PRODUCT_LINE_ITEM_WRAPPER: "PROMOTIONS_product_line_item_wrapper",
    PRODUCT_LINE_ITEM_CLOSE_ICON: "PROMOTIONS_product_line_item_close_icon",
    PRODUCT_LINE_ITEM_IMAGE: "PROMOTIONS_product_line_item_list_image",

    AUTOCOMPLETE_SELECT_RULE_SEARCHFIELD: "PROMOTIONS_autocomplete_select_rule_searchfield",

    CIRCULAR_PROGRESS: "PROMOTIONS_circular_progress",
    ELIGIBILITY_RULES_CIRCULAR_PROGRESS: "PROMOTIONS_eligibility_rules_circular_progress",
    PAGE_CIRCULAR_PROGRESS: "PROMOTIONS_PAGE_circular_progress",

    ELIGIBILITY_RULES_ERRORS: "PROMOTIONS_eligibility_rules_errors",
    ELIGIBILITY_RULES_DELETE_BUTTON: "PROMOTIONS_ELIGIBILITY_RULES_delete_button",
    ELIGIBILITY_RULES_ADD_BUTTON: "PROMOTIONS_ELIGIBILITY_RULES_add_button",
    DELETE_MODAL: "PROMOTIONS_delete_modal",
    DUPLICATE_MODAL: "PROMOTIONS_duplicate_modal",
    DELETE_MODAL_DIALOG_CONFIRM: "PROMOTIONS_delete_modal_dialog_confirm",
    DELETE_MODAL_DIALOG_CANCEL: "PROMOTIONS_delete_modal_dialog_cancel",
    DUPLICATE_MODAL_DIALOG_CONFIRM: "PROMOTIONS_duplicate_modal_dialog_confirm",
    DUPLICATE_MODAL_DIALOG_CANCEL: "PROMOTIONS_duplicate_modal_dialog_cancel",
    DUPLICATE_MODAL_TEXTFIELD: "PROMOTIONS_duplicate_modal_textfield",

    LIST_EDIT_ICON: "PROMOTIONS_LIST_edit_icon",
    LIST_FILECOPY_ICON: "PROMOTIONS_LIST_filecopy_icon",
    LIST_DELETE_ICON: "PROMOTIONS_LIST_delete_icon",
    LIST_ACTIVATE_ICON: "PROMOTIONS_LIST_activate_icon",
    LIST_DEACTIVATE_ICON: "PROMOTIONS_LIST_deactivate_icon",
    LIST_LIST: "PROMOTIONS_LIST_list",
    LIST_HEADER_CHECKBOX: "PROMOTIONS_LIST_header_checkbox",
    LIST_ROW_CHECKBOX: "PROMOTIONS_LIST_row_checkbox",
    LIST_ROW_WRAPPER: "PROMOTIONS_LIST_row_wrapper",
    LIST_NAME: "PROMOTIONS_LIST_name",
    LIST_STATUS: "PROMOTIONS_LIST_status",

    FILTER_TYPE: "PROMOTIONS_LIST_FILTER_type",
    FILTER_TYPE_PRODUCT: "PROMOTIONS_LIST_FILTER_type_product",
    FILTER_TYPE_ORDER: "PROMOTIONS_LIST_FILTER_type_order",
    FILTER_STATUS: "PROMOTIONS_LIST_FILTER_status",
    FILTER_STATUS_ACTIVE: "PROMOTIONS_LIST_FILTER_status_active",
    FILTER_STATUS_INACTIVE: "PROMOTIONS_LIST_FILTER_status_inactive",
    FILTER_DATE_RANGE: "PROMOTIONS_LIST_FILTER_date_range",
    FILTER_DATE_RANGE_FROM: "PROMOTIONS_LIST_FILTER_date_range_from",
    FILTER_DATE_RANGE_TO: "PROMOTIONS_LIST_FILTER_date_range_to",
    FILTER_DATE_RANGE_SUBMIT: "PROMOTIONS_LIST_FILTER_date_range_submit",
    FILTER_CREATED_BY: "PROMOTIONS_LIST_FILTER_created_by",
    FILTER_CLEAR: "PROMOTIONS_LIST_FILTER_clear",

    PAGE_CANCEL_BUTTON: "PROMOTIONS_PAGE_cancel_button",
    PAGE_SAVE_BUTTON: "PROMOTIONS_PAGE_save_button",

    PROMOTION_TYPE_MODAL_WRAPPER: "PROMOTION_TYPE_MODAL_wrapper",
    PROMOTION_TYPE_MODAL_ITEM: "PROMOTION_TYPE_MODAL_promotion_type",
};
